import { ReactRenderer } from '@tiptap/react'

import { tippy } from '../../../utils/tippy.js'
import { Mention } from '../../@types/index.js'

import { MentionList, MentionListProps } from './List.js'

import { MentionOptions } from './index.js'

export const mention = ({
  document,
  search,
  cachedMentions,
}: {
  document: Document
  cachedMentions: Mention[]
  search: MentionListProps['search']
}): MentionOptions['suggestion'] => ({
  items: () => [],
  decorationTag: 'a',
  render: () => {
    let reactRenderer
    let popup

    return {
      onStart: props => {
        reactRenderer = new ReactRenderer(MentionList, {
          props: { ...props, search, cachedMentions },
          editor: props.editor,
        })

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () =>
            document.getElementById('composer-editor-wrapper') || document.body,
          content: reactRenderer.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          popperOptions: {
            strategy: 'fixed',
          },
          placement: 'bottom-start',
        })
      },

      onUpdate(props) {
        reactRenderer.updateProps(props)

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        })
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup[0].hide()

          return true
        }

        return reactRenderer.ref?.onKeyDown(props)
      },

      onExit() {
        popup[0].destroy()
        reactRenderer.destroy()
      },
    }
  },
})
